var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrameioIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 124.11 141.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #5b53ff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m8.08,141.8c-5.8,0-9.6-6-7.5-11.4,7.2-18.5,11.1-38.5,11.1-59.5S7.78,29.8.58,11.4C-1.52,6,2.28,0,8.08,0c3.1,0,6,1.9,7.1,4.8,8.1,20.5,12.5,42.8,12.5,66.1s-4.4,45.7-12.5,66.1c-1.1,3-3.9,4.8-7.1,4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m46.58,125.8c-5.3,0-9.1-5.1-7.9-10.2,3.3-14.3,5.1-29.3,5.1-44.7s-1.8-30.3-5.1-44.7c-1.2-5.2,2.6-10.2,7.9-10.2,3.6,0,6.8,2.4,7.6,5.9,3.7,15.7,5.7,32.1,5.7,49s-2,33.2-5.7,49c-.8,3.5-4,5.9-7.6,5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m82.98,101.7c-4.8,0-8.6-4.3-8.1-9.1.7-7.1,1-14.4,1-21.7s-.3-14.6-1-21.7c-.5-4.8,3.3-9.1,8.1-9.1,4,0,7.4,3,7.8,7,.8,7.8,1.1,15.8,1.1,23.8s-.4,16-1.1,23.8c-.3,4-3.7,7-7.8,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m117.18,60.6l4.6,4.6c3.1,3.1,3.1,8.2,0,11.4l-4.6,4.6c-3.4,3.4-9.1,1-9.1-3.8v-13c0-4.8,5.7-7.1,9.1-3.8Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameioIcon);
export default __webpack_public_path__ + "static/media/frame.io-icon.f427d3636c90f3b151875f8a251463c9.svg";
export { ForwardRef as ReactComponent };